function Details(renderer) {

  this.createAlternatives = function (recommendations, current) {
    const self = this
    return recommendations.reduce((strategies, funds) => {
      const id = self.id(funds)
      if (id !== current.id && strategies.length < 2) {
        strategies.push({
          funds: funds,
          id: id,
          shortDescription: self.strategyDescription(id),
          strategy: self.strategyPill(funds),
          donutClass: 'accent-info',
        })
      }
      return strategies
    }, [])
  }

  this.selectFund = function (fundId, currentId) {
    const chart = $(".ct-chart")
    chart.find('.ct-series').removeClass('selected')
    chart.find('.line-' + fundId).addClass('selected')
    const recommendationDescriptionsContainer = $("#recommendation-descriptions")
    recommendationDescriptionsContainer.find('.collapse').collapse('hide')
    recommendationDescriptionsContainer.find('#recommendation-description-' + fundId).collapse('show')
  }

  this.initializeChart = function (params) {
    const normalizedSeries = params.lines.series.map(function (series) {
      const normalization = 100 / series.data.filter(function (item) {
        return item !== null
      })[0];
      series.data = series.data.map(function (item) {
        return item && item * normalization
      });
      return series;
    });

    const chartData = {
      labels: params.lines.labels,
      series: normalizedSeries
    };

    new Chartist.Line('#pillarChart', chartData, {
      fullWidth: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return value - 100 + "%";
        },
        position: 'end'
      },
      chartPadding: {top: 12, right: 0, bottom: 0, left: 30}
    }).on('draw', function () {
      const line = $('.ct-line, .ct-point')
      const legend = $('#chart-legend')
      line.on('mouseover', function () {
        const series = $(this).closest('.ct-series')
        series.addClass('ct-series-hover')
        legend.html(series.attr('ct:series-name'))
        legend.removeClass('hidden')
      });

      line.on('mouseout', function () {
        const series = $(this).closest('.ct-series')
        series.removeClass('ct-series-hover')
        legend.addClass('hidden')
      });
    })
  }

  this.lines = function (alternatives, current) {
    const lastYear = new Date().getFullYear() - 1
    const labels = []
    for (let i = lastYear - 9; i <= lastYear; i++) labels.push(i)
    return {
      labels: labels,
      series: this.series(alternatives, current)
    }
  }

  this.lineClasses = function (strategy, current) {
    let classes
    if (current) classes = 'ct-series-current selected'
    else classes = 'ct-series-alternative'
    return classes + ' line-' + strategy.id
  }

  this.series = function (alternatives, current) {
    const self = this
    return alternatives.concat(current).reduce((memo, strategy, i) => {
      const data = self.weightedAverage(strategy.funds)
      if (self.hasChartPoints(data))
        memo.push({
          className: self.lineClasses(strategy, i === 2),
          name: self.strategyName(strategy),
          data: data
        })
      return memo
    }, [])
  }

  this.weightedAverage = function (funds) {
    const chart = []
    for (let i = 0; i < 10; i++) {
      const point = funds.reduce((value, recommendation) => {
        const data = NavChart[recommendation.fund.isin]
        if (data && data[i]) value += (data[i] * recommendation.percent / 100)
        return value
      }, null)

      const allPointsExist = funds.reduce((exists, recommendation) =>
        exists && NavChart[recommendation.fund.isin] && NavChart[recommendation.fund.isin][i], true)

      chart[i] = allPointsExist ? point : null
    }
    return chart
  }

  this.hasChartPoints = function (points) {
    return points.filter(point => point).length > 0
  }

  this.recommendationDescriptions = function (alternatives, current) {
    const self = this
    return alternatives.concat(current).map(function (strategy) {
      return {
        id: 'recommendation-description-' + strategy.id,
        description: self.recommendationDescription(strategy.id),
        visibility: strategy.id === current.id ? 'collapse show' : 'collapse',
        chartMissing: (self.hasChartPoints(self.weightedAverage(strategy.funds)) || !strategy.funds.length)
          ? ''
          : renderer.label('chartMissing', {hash: [self.strategyName(strategy).replace(/<br\/>/g, ' ')]})
      }
    })
  }

  this.recommendationDescription = function (strategyId) {
    return Labels['pension-strategy-description-' + strategyId]
  }

  this.strategyLink = function () {
    $('.strategy-link').click(function (e) {
      e.preventDefault()
      const details = $('#strategy-details')
      $('html, body').animate({
        scrollTop: details.offset().top
      })
    })
  }
}